import type { IAppsFilterOptionsDto } from "../types/descriptionDto";

export const EMPTY_DESCRIPTION: IAppsFilterOptionsDto = {
    androidAdsSellers: { inclusionOptions: [], operatorOptions: [], adsSellerDomainNames: [] },
    androidCategory: { categories: [] },
    androidDownloadsAndEngagement: {
        monthlyActiveUsersBuckets: [],
        monthlyDownloadsBuckets: [],
        supportedCountries: [],
    },
    androidPermission: { operatorOptions: [], permissions: [] },
    appBusinessModels: [],
    iabCategories: { categories: [], inclusionOptions: [] },
    iosAdsSellers: { inclusionOptions: [], operatorOptions: [], adsSellerDomainNames: [] },
    iosCategory: { categories: [], primaryCategories: [], types: [] },
    iosDownloadsAndEngagement: {
        monthlyActiveUsersBuckets: [],
        monthlyDownloadsBuckets: [],
        supportedCountries: [],
        devices: [],
    },
    iosIdentifiers: { identifiers: [] },
    iosPermission: { operatorOptions: [], permissions: [] },
    priceFilter: { buckets: [], priceTypes: [] },
    rating: { numberOfRatingsBuckets: [] },
    sdksFilter: { inclusionOptions: [], operatorOptions: [], sdksDescriptions: [] },
    releaseDate: { ranges: [], rangeTypes: [] },
    updateDate: { ranges: [], rangeTypes: [] },
};
